import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { SnotifyService } from 'ng-snotify';
import { AuthService } from '../../../../services/auth.service';
import { CompanyService } from '../../../../services/company.service';
import { Company } from '../../../../models/company';
import { UUID } from "angular2-uuid";

@Component({
  selector: 'app-company-mange',
  templateUrl: './company-mange.component.html',
  styleUrls: ['./company-mange.component.scss']
})
export class CompanyManageComponent implements OnInit {
  @Output() added: EventEmitter<Company> = new EventEmitter<Company>();
  @Input() saveTrigger = false;
  @Input() hideSaveOption = false;
  @Input() selectedCompany: Company;
  @Input() user;

  company: Company;
  
  constructor(private snotifyService: SnotifyService, public router: Router, public companyService: CompanyService) {
  }


  ngOnInit(): void {
    ///Load any data
    this.company = new Company();
    this.company.addLocation = true;
    //console.log(this.hideSaveOption)
  }

  ngOnChanges(changes: SimpleChanges) {
    //console.log(changes);
    if (changes.saveTrigger != null && changes.saveTrigger.currentValue != null) {
      this.submit();
    }
    if (changes.selectedCompany != null && changes.selectedCompany.currentValue != null) {
      this.company = changes.selectedCompany.currentValue;
      this.company.addLocation = false;
    }
  }
  submit() {
    var msg = this.isValid(this.company);
    if (msg.length == 0) {
      //console.log("no error with");
      //console.log(this.company);
      this.company.userId = this.user.id;
      var editing: boolean = true;
      if (!this.isValidString(this.company.id)) {
        this.company.id = UUID.UUID();
        editing = false;
      }

      this.companyService.addorupdate(this.company).then((c) => {
        this.snotifyService.success("Successfully " +(editing? "updated" : "added") + " Company")
        this.added.emit(this.company);

      }, (err) => {
        this.snotifyService.error("error saving Company")
      })
    }

  }
  isValid(company: Company) {
    var message = "";
    if (this.company == undefined || this.company == null) {
      message = "unknown error on company" + "\n\r";
    } else {
      if (!this.isValidString(this.company.name)) {
        this.snotifyService.error("Please enter a name");
        message += " name ";
      }
      if (!this.isValidString(this.company.account_Number)) {
        this.snotifyService.error("Please enter a account number");
        message += " account_Number ";
      }
    }
    return message;
  }

  isValidString(str: string) {
    var valid = true;

    if (str == null || str == undefined || str.length === 0 || str === '' || str === ' ')
      valid = false;

    return valid;
  }
}

